import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "../../../store";
import {
  updateFormData,
  createTalentRegisterLink,
  getTalentRegisterLinks,
  updateTalentRegisterLink,
  resetForm,
  setError,
  setCurrentPage,
} from "../../../reducers/talentRegisterLink";
import { setIsFromTagsList } from "reducers/talentTag";

import CustomIconButton from "../../../components/CustomIconButton";
import CustomButton from "../../../components/CustomButton";
import Dropdown from "../../../components/Dropdown";
import CustomTextarea from "../../../components/CustomTextarea";
import CustomSwitch from "../../../components/CustomSwitch";
import QRCodeWithLogo from "../../../components/QRCodeWithLogo";
import logo from "../../../../assets/img/symbol_20250311.png"
import { formatDate } from "../../../utils/format";
import RegisterLinkTagsPanel from "./RegisterLinkTagsPanel";
import { validateFieldReq } from "../../../utils/validation";
import { downloadQRCodeWithLogo, handleCopy } from "../../../utils/util";
import { STAFF_TYPE, TALENT_TYPE } from "../../../constants/index";

const initFormError = {
  attribute: "",
}

const RegistrationLinkPanel = ({ onClose }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isTagsPanel, setIsTagsPanel] = useState(false);
  const [isShowMsg, setIsShowMsg] = useState(false);
  const {staffInfo} = useSelector((state: any) => state.currentUser);
  const { formData, mode, selectedRecord, currentPage } = useSelector(
    (state: RootState) => state.talentRegisterLink
  );
  const [formError, setFormError] = useState(initFormError);
  const currentUser = useSelector((state: any) => state.currentUser);
  const companyUrlSlug = currentUser?.staffInfo?.company?.url_slug;
  const isPublicAlumni = currentUser?.staffInfo?.company?.is_public_alumni;
  const isPublicExternal = currentUser?.staffInfo?.company?.is_public_external_talent;
  const isPublicInternal = currentUser?.staffInfo?.company?.is_public_internal_talent;
  const registerLink = selectedRecord?.link?.replace("_url_slug_", companyUrlSlug)
  const {typeOptions} = useSelector((state: any) => state.companyTalent)
  const { isFromTagsList, isOpenSearchTagsPanel } = useSelector((state: any) => state.talentTag);
  const [disableLink, setDisableLink] = useState(false);

  const isView = mode === "view";

  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (isFromTagsList && isOpenSearchTagsPanel) {
      setIsTagsPanel(true);

      // Check disable リンクを有効にする
      if(formData.attribute) {
        changeAttribute(formData.attribute, false)
      }
      
      setTimeout(() => {
        dispatch(setIsFromTagsList(false));
      }, 2000);
    }
  }, [location.state]);

  useEffect(() => {
    changeDisableLink()
  }, [selectedRecord]);

  let formErrors = {
    ...initFormError,
  };

  const getNameById = (id: any, items: any) => {
    if (!id) { return null; }
    for(let item of items) {
      if (item.id == id) { return item.name; }
    }
    return null;
  };

  const triggerMessage = () => {
    setIsShowMsg(true);
    setTimeout(() => {
      setIsShowMsg(false);
    }, 3000);
  }

  const validateFormData = () => {
    const validateTitleReq = validateFieldReq(formData.attribute, "タレント種別");
    if(validateTitleReq != true) {
      formErrors.attribute = String(validateTitleReq);
    }

    setFormError(formErrors);

    const errorText: any = Object.entries(formErrors).find(([key, value]) => value !== "");

    return {
      isValid: !Object.values(formErrors).some((error) => error),
      error: errorText && errorText[1] ? errorText[1] : null,
    };
  }

  const handleUpdateRegisterLink = async (e: React.FormEvent) => {
    e.preventDefault();
    const data = {
      id: selectedRecord?.id,
      description: formData.explanation,
      is_enable_link: formData.is_link_enabled
    }
    const res = await dispatch(updateTalentRegisterLink({requestBody: data}));
    if(res && res.payload && res.payload.success) {
      dispatch(getTalentRegisterLinks({page: currentPage, pageSize: 10, sortBy: "public_date", sortOrder: "desc"}));
      onClose();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { isValid, error } = validateFormData(formData);
    
    if (!isValid) {
      dispatch(setError(error));
      return false;
    }
    if (!isView) {
      const tagIds = Array.isArray(formData.tags)
        ? formData.tags.map((t: any) => t.id).join(",")
        : "";
      const data = {
        requestBody: {
          talent_role: formData.attribute?.id,
          tag_ids: tagIds,
          description: formData.explanation,
          is_enable_link: formData.is_link_enabled
        }
      }
      const res = await dispatch(createTalentRegisterLink(data));
      if(res && res.payload && res.payload.success) {
        dispatch(setCurrentPage(1));
        dispatch(getTalentRegisterLinks({page: 1, pageSize: 10, sortBy: "public_date", sortOrder: "desc"}));
        dispatch(resetForm());
        dispatch(setError(null));
        onClose();
      }
    }
  };
  
  const changeAttribute = (item: any, isEnableLink=false) => {
    dispatch(updateFormData({ attribute: item }))
    if(!item || !item.value) {
      return
    }

    if(
      (!isPublicAlumni && item.value == TALENT_TYPE.ALUMNI) || 
      (!isPublicExternal && item.value == TALENT_TYPE.EXTERNAL) || 
      (!isPublicInternal && item.value == TALENT_TYPE.INTERNAL)
    ) {
      if(isEnableLink) {
        dispatch(updateFormData({ is_link_enabled: false }))
      }
      setDisableLink(true)
    } else {
      if(isEnableLink) {
        dispatch(updateFormData({ is_link_enabled: true }))
      }
      setDisableLink(false)
    }
  }

  const changeDisableLink = () => {
    if(selectedRecord && selectedRecord?.talent_role?.value) {
      if(
        (!isPublicAlumni && selectedRecord?.talent_role?.value == TALENT_TYPE.ALUMNI) || 
        (!isPublicExternal && selectedRecord?.talent_role?.value == TALENT_TYPE.EXTERNAL) || 
        (!isPublicInternal && selectedRecord?.talent_role?.value == TALENT_TYPE.INTERNAL)
      ) {
        dispatch(updateFormData({ is_link_enabled: false }))
        setDisableLink(true)
      }
    } 
  }

  return (
    <div className="min-w-[28rem] max-w-[28rem] bg-white rounded-2xl pt-3 alu-panel-box-shadow h-full flex flex-col pb-4">
      {!isTagsPanel && <div className="px-4 flex items-center justify-between">
        <h3 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">
          {mode === "create" && "登録リンクの発行"}
          {mode === "edit" && "登録リンクの情報"}
          {mode === "view" && "登録リンクの情報"}
        </h3>
        <CustomIconButton onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
          </svg>
        </CustomIconButton>
      </div>}

      {!isTagsPanel ? <><div className="overflow-y-auto custom-scrollbar h-[calc(100%-72px)] px-4">
        <form className="mt-6 w-full flex flex-col">
            {mode !== "create" && (
            <>
              <div className="mb-6">
                <label className="block mb-2 text-sm font-bold alu-text-base-2">
                  登録リンクコード
                </label>
                <p className="text-sm alu-text-base-2">{selectedRecord?.code}</p>
              </div>

              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-bold alu-text-base-2">
                    リンク
                  </label>
                  <div className="flex items-center">
                    <p className={`text-[#000] text-xs leading-[18px] transition-opacity duration-300 ${isShowMsg ? "opacity-100" : "opacity-0"}`}>コピーしました！</p>
                    <CustomButton disabled={isShowMsg} size="sm" variant="text" type="button" onClick={() => handleCopy(registerLink, triggerMessage)}>
                      コピー
                    </CustomButton>
                  </div>
                </div>
                <div className="flex items-center gap-2 border alu-border rounded-lg p-4">
                  <p className="text-sm alu-text-base-2 break-all">{registerLink}</p>
                </div>
              </div>

              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-bold alu-text-base-2">
                    QR コード
                  </label>
                  <CustomButton size="sm" variant="text" type="button" onClick={() => downloadQRCodeWithLogo(canvasRef.current, `QR${selectedRecord?.code}.png`)}>
                    ダウンロード
                  </CustomButton>
                </div>
                <div className="flex items-center justify-center px-4 py-2 border alu-border rounded-lg">
                  <QRCodeWithLogo value={registerLink} canvasRef={canvasRef} marginSize={4} />
                </div>
              </div>
            </>
            )}
            <div className="mb-6">
              <label className={`block mb-2 text-sm font-bold alu-text-base-2 pointer-events-none`} htmlFor="attribute">タレント種別 {!["view", "edit"].includes(mode) && <span className="alu-text-error">*</span>}</label>
              {!["view", "edit"].includes(mode) ? <Dropdown
                  disabled={isView}
                  inputWidth="full"
                  placeholder="選択してください"
                  options={typeOptions}
                  value={formData.attribute}
                  error={formError.attribute.length > 0}
                  errorText={formError.attribute}
                  onChange={(value: any) => changeAttribute(value, true)}
              /> : <p className="alu-text-base-2 text-sm">{getNameById(selectedRecord?.talent_role?.id, typeOptions)}</p>}
            </div>
            <div className={`mb-6`} >
              <label className={`block mb-2 text-sm font-bold alu-text-base-2 pointer-events-none`} htmlFor="tags">
                タグ
              </label>
              {!["view", "edit"].includes(mode) && <p className="text-sm alu-text-base-1 mb-2">最大10個まで選択できます</p>}
              <div className="flex flex-wrap items-center gap-2 text-sm alu-text-base-2">
                {formData?.tags.length > 0 ? 
                  [...formData.tags]
                  .sort((a, b) => (a?.title || '').localeCompare(b?.title || ''))
                  .map((tag) => (
                    <div
                      key={tag?.id}
                      className="px-2 py-[0.125rem] text-center rounded-sm bg-[#F7F7F7]"
                    >
                      {tag?.title}
                    </div>)) 
                    : 
                    ["view", "edit"].includes(mode) ? "ー" : ""
                }
                {!["view", "edit"].includes(mode) && 
                <CustomButton variant="text" onClick={() => setIsTagsPanel(true)}>
                  編集
                </CustomButton>}
              </div>
            </div>
            <div className={`mb-6`} >
              <label className={`block mb-2 text-sm font-bold alu-text-base-2 pointer-events-none`} htmlFor="explanation">
                説明
              </label>
              <CustomTextarea
                id="explanation"
                name="explanation"
                disabled={isView || staffInfo?.type == STAFF_TYPE.GENERAL}
                maxLength={400}
                placeholder="入力してください"
                value={formData.explanation}
                onChange={(e: any) => dispatch(updateFormData({ explanation: e.target.value }))}
              />
            </div>

            <div className={`${mode === "create" ? "mb-10" : "mb-6"} flex items-center gap-4`}>
              <label className="block text-sm alu-text-base-2 pointer-events-none">リンクを有効にする</label>
              <CustomSwitch
                disabled={isView || staffInfo?.type == STAFF_TYPE.GENERAL || disableLink}
                checked={formData.is_link_enabled}
                onChange={(e: any) => dispatch(updateFormData({ is_link_enabled: e.target.checked }))}
              />
            </div>

            {mode !== "create" && <div className="mb-10">
              <label className="block mb-2 text-sm font-bold alu-text-base-2 pointer-events-none">発行日</label>
              <p className="text-sm alu-text-base-2">{selectedRecord?.public_date ? formatDate(selectedRecord?.public_date) : 'ー'}</p>
            </div>}
        </form>
      </div>
      {!isView && (
        <div className="flex items-center justify-between px-4 pt-4 gap-4">
          <CustomButton type="button" width="full" variant="outline" size="md" onClick={onClose}
            disabled={staffInfo?.type == STAFF_TYPE.GENERAL}>
            キャンセル
          </CustomButton>
          <CustomButton onClick={(e) => mode === "create" ? handleSubmit(e) : handleUpdateRegisterLink(e)} 
            type="button" size="md" width="full" disabled={staffInfo?.type == STAFF_TYPE.GENERAL}>
            {mode === "edit" ? "保存" : "発行"}
          </CustomButton>
        </div>
      )}
      </>
      : <RegisterLinkTagsPanel onClose={onClose} setIsTagsPanel={setIsTagsPanel} />
    }
    </div>
  );
};

export default RegistrationLinkPanel;
